import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { Reservation, TransientReservation } from '../models/reservation';
import { TransientReservationService } from './transient-reservation-http-service';
import { TransientReservationSearchParameters } from '../models/transient-reservation-search-params';
import { catchError, take } from 'rxjs/operators';
import { Page } from '../../shared/models/page';
import { LogService } from '../../shared/log/log.service';

@Injectable()
export class TransientReservationStore {

  private searchResultsPage: BehaviorSubject<Page<TransientReservation>> = new BehaviorSubject(Page.empty<TransientReservation>());

  constructor(
    private flashMessagesService: FlashMessagesService,
    private transientReservationHttpService: TransientReservationService,
    private logService: LogService
  ) {}

  setTransientReservationPage(page: Page<TransientReservation>): void {
    this.searchResultsPage.next(page);
  }

  linkTransientReservationToEvent(eventReservationId: number, eventId: number, doNotPay?: boolean): Observable<Reservation> {
    return this.transientReservationHttpService.linkTransientReservationToEvent(eventReservationId, eventId, doNotPay)
      .pipe(
        take(1),
        catchError((error: any) => {
          this.flashMessagesService.error(
            'MESSAGES.ERROR.LINK_TRANSIENT_RESERVATION',
            `Error linking a transient reservation to an event: ${error}`
          );
          return Observable.throw(error);
        }),
      );
  }

  searchTransientReservations(searchParameters: TransientReservationSearchParameters,
                                  page: number,
                                  size: number): Observable<Page<TransientReservation>> {
    this.logService.debug(`searchParameters: ${searchParameters}`);

    return this.transientReservationHttpService.search(searchParameters, page, size)
      .catch((error: any) => {
        this.flashMessagesService.error(
          'MESSAGES.ERROR.SEARCH_TRANSIENT_RESERVATION',
          `Error retrieving transient reservations: ${error}`);
        return Observable.throw(error);
      })
      .map((res: Page<TransientReservation>) => {
        this.searchResultsPage.next(res);
        this.logService.debug(`searchResult: ${res}`);
        return res;
      });
  }

  get searchResults(): Observable<Page<TransientReservation>> {
    return this.searchResultsPage.asObservable();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/service/transient-reservation-store.ts